import { inject } from '@angular/core';
import { MyAuthService } from './auth.service';
import { tap } from 'rxjs';
import { CanActivateFn } from '@angular/router';

export const authGuard: CanActivateFn = () => {
  const authService = inject(MyAuthService);

  return authService.isLoggedIn$.pipe(
    tap((loggedIn) => {
      if (!loggedIn) {
        authService.loginWithAuth0();
      }
    }),
  );
};
